import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { Auth } from '../../components/Auth/Auth';
import { isAuthenticated, getUser } from '../../api/client';
import { updateAuthState } from '../../App';

export const AuthPage: React.FC = () => {
  const navigate = useNavigate();
  const authenticated = isAuthenticated();
  
  // 既に認証済みの場合はダッシュボードにリダイレクト
  if (authenticated) {
    return <Navigate to="/" replace />;
  }

  const handleAuthSuccess = () => {
    console.log('handleAuthSuccess called in AuthPage');
    // App コンポーネントの認証状態を更新
    const user = getUser();
    console.log('Current user:', user);
    updateAuthState(true, user);
    
    // 認証後はReact Routerでダッシュボードに遷移
    console.log('Navigating to dashboard');
    navigate('/');
  };

  return <Auth onAuthSuccess={handleAuthSuccess} />;
};